import React from "react";
// import "react-multi-carousel/lib/styles.css";

const Blog = ({ blog }) => {
  const { img, title, blogLink } = blog;
  return (
    <div className='col-sm-6 col-md-4 mb-3'>
      <div className='card blog-card'>
        <img className='card-img-top' src={img} alt='Card cap' />
        <div className='card__bg'>
          <div className='card-body'>
            <h5 className='card-title text-white text-center'>{title}</h5>
          </div>
          <div className='card-footer' id='card-footer-container'>
            {blogLink ? (
              <a
                class='btn btn-danger btn-block'
                href={blogLink}
                target='_blank'
                role='button'
              >
                <strong> Read More </strong>
              </a>
            ) : (
              <a
                class='btn btn-danger btn-block'
                href='https://www.google.com/'
                target='_blank'
                role='button'
              >
                <strong> Read More </strong>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
    // <div className='col-sm-6 col-md-4'>
    //   <div className='card card-container mb-5'>
    //     <img
    //       style={{ height: "250px" }}
    //       className='card-img-top'
    //       src={blog.img}
    //       alt='Card cap'
    //     />
    //     <div className='card-body'>
    //       <h4
    //         style={{ fontWeight: "700", color: "#f0f0f0" }}
    //         className='card-title'
    //       >
    //         {blog.title}
    //       </h4>
    //       <p style={{ color: "#f0f0f0" }} className='card-text text-white'>
    //         {blog.description}
    //       </p>
    //     </div>
    //     <div className='card-footer' id='card-footer-container'>
    //       {blog.blogLink ? (
    //         <a
    //           class='btn btn-info btn-block'
    //           href={blog.blogLink}
    //           target='_blank'
    //           role='button'
    //         >
    //           <strong> Read More </strong>
    //         </a>
    //       ) : (
    //         <a
    //           class='btn btn-info btn-block'
    //           href='https://www.google.com/'
    //           target='_blank'
    //           role='button'
    //         >
    //           <strong> Read More </strong>
    //         </a>
    //       )}
    //     </div>
    //   </div>
    // </div>
  );
};

export default Blog;
